import * as React from 'react';

function SvgReferralBonus(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32.047} height={32} {...props}>
      <defs>
        <style>
          {
            '.referral_bonus_svg__prefix__cls-2,.referral_bonus_svg__prefix__cls-3{fill:#00cd00}.referral_bonus_svg__prefix__cls-3{stroke:transparent}'
          }
        </style>
      </defs>
      <g id="referral_bonus_svg__prefix__referral_bonus" transform="translate(-136 -478)">
        <path
          id="referral_bonus_svg__prefix__bounds"
          d="M0 0h32v32H0z"
          transform="translate(136 478)"
          fill="none"
        />
        <g id="referral_bonus_svg__prefix__Expand" transform="translate(135 476.1)">
          <path
            id="referral_bonus_svg__prefix__Path_5612"
            d="M30.977 49.866h-1.035v-4.657h1.552v-1.035h-1.552V43.14h2.587a.517.517 0 00.366-.883l-3.1-3.1a.517.517 0 00-.37-.157H5.622a.517.517 0 00-.366.152l-3.1 3.1a.517.517 0 00.366.883h2.07v6.727H2V50.9h28.977zm-2.07 0H22.7v-4.657h6.209zm-17.593-8.279v8.279h-1.035V41.8l1.552-1.552 2.739 2.739a.517.517 0 00.366.152h4.14v1.035h-2.07v1.035h2.07v4.657h-6.727v-8.279zM8.727 43.14a.517.517 0 00.366-.152l.152-.152v7.03H7.692V43.14zm12.936 0v1.035h-1.552V43.14zm-1.552 2.07h1.552v4.657h-1.552zm8.8-1.035H22.7V43.14h6.209zm.3-4.14l2.07 2.07H15.15l-2.07-2.07zm-23.374 0h4.746L8.513 42.1H3.767zm-.214 3.1h1.034v6.727H5.622z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5612"
            transform="translate(0 -17.42)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2092"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2092"
            transform="translate(14.936 26.754)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2093"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2093"
            transform="translate(32.012 32.446)"
          />
          <path
            id="referral_bonus_svg__prefix__Path_5614"
            d="M3 21.174a5.174 5.174 0 101.516-3.659A5.174 5.174 0 003 21.174zm5.174-4.14a4.14 4.14 0 11-2.927 1.212 4.14 4.14 0 012.927-1.212z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5614"
            transform="translate(-.483 -6.321)"
          />
          <path
            id="referral_bonus_svg__prefix__Path_5616"
            d="M47.174 16a5.174 5.174 0 103.659 1.516A5.174 5.174 0 0047.174 16zm2.926 8.1a4.14 4.14 0 111.212-2.927A4.14 4.14 0 0150.1 24.1z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5616"
            transform="translate(-19.302 -6.321)"
          />
          <path
            id="referral_bonus_svg__prefix__Path_5618"
            d="M33.349 8.174a5.174 5.174 0 10-5.174 5.174 5.174 5.174 0 005.174-5.174zm-5.174 4.14a4.14 4.14 0 114.14-4.14 4.14 4.14 0 01-4.141 4.14z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5618"
            transform="translate(-10.134 -.048)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2094"
            d="M0 0h1.035v6.209H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2094"
            transform="translate(17.006 14.336)"
          />
          <path
            id="referral_bonus_svg__prefix__Path_5619"
            d="M35 33.14h1.035v-2.07a1.035 1.035 0 011.035-1.035V29A2.07 2.07 0 0035 31.07z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5619"
            transform="translate(-15.924 -12.595)"
          />
          <path
            id="referral_bonus_svg__prefix__Path_5620"
            d="M27.07 32.174v-3.1A2.07 2.07 0 0025 27v1.035a1.035 1.035 0 011.035 1.035v3.1z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5620"
            transform="translate(-11.099 -11.63)"
          />
          <path
            id="referral_bonus_svg__prefix__Path_5621"
            d="M21.229 2.9A7.185 7.185 0 0019 8.126q0 .281.021.557l1.032-.08q-.018-.236-.018-.478a6.158 6.158 0 011.91-4.481z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Path 5621"
            transform="translate(-8.203)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2095"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2095"
            transform="translate(3.035 3.987)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2096"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2096"
            transform="translate(6.657 6.574)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2097"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2097"
            transform="translate(2.517 20.545)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2098"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2098"
            transform="translate(32.012 20.545)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2099"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2099"
            transform="translate(24.768 3.469)"
          />
          <path
            id="referral_bonus_svg__prefix__Rectangle_2100"
            d="M0 0h1.035v1.035H0z"
            className="referral_bonus_svg__prefix__cls-2"
            data-name="Rectangle 2100"
            transform="translate(29.942 7.091)"
          />
          <g
            id="referral_bonus_svg__prefix__Group_2641"
            data-name="Group 2641"
            transform="translate(16.306 5.634)"
          >
            <path
              id="referral_bonus_svg__prefix__Path_1677"
              d="M835.307 2407.259a.123.123 0 00-.09-.035h-.673a1.363 1.363 0 00-.252-.567h.917a.124.124 0 00.091-.035.123.123 0 00.035-.091v-.4a.124.124 0 00-.035-.091.122.122 0 00-.091-.035h-3.276a.122.122 0 00-.09.035.124.124 0 00-.035.091v.523a.127.127 0 00.126.126h.571q.831 0 1.055.445h-1.626a.122.122 0 00-.09.035.123.123 0 00-.035.091v.4a.122.122 0 00.126.126h1.681a.77.77 0 01-.4.492 1.778 1.778 0 01-.837.169h-.441a.128.128 0 00-.126.126v.5a.117.117 0 00.035.086q.756.8 1.961 2.248a.116.116 0 00.1.048h.768a.114.114 0 00.114-.071.107.107 0 00-.016-.134q-1.15-1.41-1.807-2.11a1.994 1.994 0 001.087-.434 1.471 1.471 0 00.508-.921h.661a.122.122 0 00.126-.126v-.4a.123.123 0 00-.042-.091z"
              className="referral_bonus_svg__prefix__cls-3"
              data-name="Path 1677"
              transform="translate(-831.807 -2406.003)"
            />
          </g>
          <g
            id="referral_bonus_svg__prefix__Group_2642"
            data-name="Group 2642"
            transform="rotate(-30 28.375 -1.369)"
          >
            <path
              id="referral_bonus_svg__prefix__Path_1677-2"
              d="M3.5 1.256a.123.123 0 00-.09-.035h-.673a1.363 1.363 0 00-.252-.567H3.4a.125.125 0 00.092-.036.123.123 0 00.036-.091v-.4A.121.121 0 003.4 0H.126a.122.122 0 00-.09.035A.124.124 0 000 .126v.523a.121.121 0 00.037.089.121.121 0 00.089.037H.7q.831 0 1.055.445H.126a.122.122 0 00-.09.035.123.123 0 00-.036.091v.4a.122.122 0 00.126.126h1.681a.77.77 0 01-.4.492 1.778 1.778 0 01-.837.169H.126a.121.121 0 00-.089.037.121.121 0 00-.037.091v.5a.117.117 0 00.035.086Q.791 4.052 2 5.5a.116.116 0 00.1.048h.768a.114.114 0 00.114-.071.107.107 0 00-.016-.134q-1.15-1.41-1.807-2.11A1.994 1.994 0 002.24 2.8a1.471 1.471 0 00.508-.921h.662a.122.122 0 00.126-.126v-.4a.123.123 0 00-.036-.097z"
              className="referral_bonus_svg__prefix__cls-3"
              data-name="Path 1677"
            />
          </g>
          <g
            id="referral_bonus_svg__prefix__Group_2643"
            data-name="Group 2643"
            transform="rotate(31 -7.508 55.422)"
          >
            <path
              id="referral_bonus_svg__prefix__Path_1677-3"
              d="M3.5 1.256a.123.123 0 00-.09-.035h-.673a1.363 1.363 0 00-.252-.567H3.4a.125.125 0 00.092-.036.123.123 0 00.036-.091v-.4A.121.121 0 003.4 0H.126a.122.122 0 00-.09.035A.124.124 0 000 .126v.523a.121.121 0 00.037.089.121.121 0 00.089.037H.7q.831 0 1.055.445H.126a.122.122 0 00-.09.035.123.123 0 00-.036.091v.4a.122.122 0 00.126.126h1.681a.77.77 0 01-.4.492 1.778 1.778 0 01-.837.169H.126a.121.121 0 00-.089.037.121.121 0 00-.037.091v.5a.117.117 0 00.035.086Q.791 4.052 2 5.5a.116.116 0 00.1.048h.768a.114.114 0 00.114-.071.107.107 0 00-.016-.134q-1.15-1.41-1.807-2.11A1.994 1.994 0 002.24 2.8a1.471 1.471 0 00.508-.921h.662a.122.122 0 00.126-.126v-.4a.123.123 0 00-.036-.097z"
              className="referral_bonus_svg__prefix__cls-3"
              data-name="Path 1677"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgReferralBonus;
